

import GpsProfileList from "@/pages/admin/asset-management/gps_integration/GpsProfileList.vue";

const gpsRoutes = [
  {
    path: "gps_integration",
    name: "app-admin-asset-management-gps-integration",
    component: GpsProfileList,
   
  },
];

export default gpsRoutes;
